var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7333 3.65332L15.6933 4.05332L11.9533 21.6533L9.99326 21.2533L13.7333 3.65332ZM20.4333 12.6533L16.8433 9.06332V6.23332L23.2633 12.6533L16.8433 19.0633V16.2333L20.4333 12.6533ZM2.42326 12.6533L8.84326 6.23332V9.06332L5.25326 12.6533L8.84326 16.2333V19.0633L2.42326 12.6533Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFe);
export default __webpack_public_path__ + "static/media/fe.52beb45e.svg";
export { ForwardRef as ReactComponent };